import React, { useState } from "react";
import Image from "../../../components/AppImage";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const CustomerMomentsSection = () => {
  const [activeCategory, setActiveCategory] = useState("all");

  const categories = [
    { id: "all", name: "All Moments", icon: "Images" },
    { id: "celebrations", name: "Celebrations", icon: "PartyPopper" },
    { id: "casual", name: "Casual Dining", icon: "Coffee" },
    { id: "groups", name: "Group Hangouts", icon: "Users" },
  ];

  const customerMoments = [
    {
      id: 1,
      category: "celebrations",
      image: "https://images.unsplash.com/photo-1714978444924-beb0b1ff6289",
      imageAlt:
        "Happy group of friends celebrating birthday at restaurant with colorful decorations, smiling faces, party hats, and festive atmosphere",
      caption: "Birthday celebration with the squad! Best tacos in town 🎉",
      author: "Priya & Friends",
      date: "2025-11-28",
      likes: 234,
    },
    {
      id: 2,
      category: "casual",
      image: "https://images.unsplash.com/photo-1672084629945-7500a3559404",
      imageAlt:
        "Young couple enjoying casual lunch date at restaurant, sharing tacos, laughing together, and having intimate conversation",
      caption: "Perfect lunch date spot! The ambience is just right ❤️",
      author: "Rahul & Sneha",
      date: "2025-11-27",
      likes: 189,
    },
    {
      id: 3,
      category: "groups",
      image:
        "https://img.rocket.new/generatedImages/rocket_gen_img_16d850cae-1764582860913.png",
      imageAlt:
        "Large group of office colleagues having team lunch, multiple dishes on table, everyone engaged in conversation and enjoying food",
      caption: "Team lunch done right! Great food, great vibes 🌮",
      author: "Tech Team Bangalore",
      date: "2025-11-26",
      likes: 312,
    },
    {
      id: 4,
      category: "casual",
      image:
        "https://img.rocket.new/generatedImages/rocket_gen_img_1b031ef44-1764582861839.png",
      imageAlt:
        "Solo diner enjoying meal at counter seat, focused on delicious taco plate, comfortable casual dining atmosphere",
      caption: "My go-to spot for solo dining. Always feel welcome here!",
      author: "Amit Kumar",
      date: "2025-11-25",
      likes: 156,
    },
    {
      id: 5,
      category: "celebrations",
      image: "https://images.unsplash.com/photo-1697387224766-05da5cf4a564",
      imageAlt:
        "Family celebrating anniversary at restaurant with multiple generations, grandparents, parents, children all smiling and enjoying meal together",
      caption: "Anniversary dinner with the whole family. Memories made! 💕",
      author: "The Sharma Family",
      date: "2025-11-24",
      likes: 278,
    },
    {
      id: 6,
      category: "groups",
      image: "https://images.unsplash.com/photo-1731149791510-76f2c2d58052",
      imageAlt:
        "Group of college students studying together at restaurant, laptops open, notebooks spread, enjoying food while working on projects",
      caption: "Study sessions taste better with tacos! 📚🌮",
      author: "College Squad",
      date: "2025-11-23",
      likes: 201,
    },
    {
      id: 7,
      category: "casual",
      image: "https://images.unsplash.com/photo-1719142510174-a311d9fa1548",
      imageAlt:
        "Two friends catching up over coffee and tacos, engaged in deep conversation, comfortable casual setting with warm lighting",
      caption: "Catching up with old friends over amazing food",
      author: "Neha & Pooja",
      date: "2025-11-22",
      likes: 167,
    },
    {
      id: 8,
      category: "celebrations",
      image: "https://images.unsplash.com/photo-1576267423048-15c0040fec78",
      imageAlt:
        "Office team celebrating project success with group photo, everyone raising drinks, happy expressions, celebratory atmosphere",
      caption: "Project launch celebration! Cheers to the team! 🎊",
      author: "Marketing Team",
      date: "2025-11-21",
      likes: 289,
    },
    {
      id: 9,
      category: "groups",
      image:
        "https://img.rocket.new/generatedImages/rocket_gen_img_15da16617-1764582862328.png",
      imageAlt:
        "Weekend brunch gathering with friends, multiple colorful dishes on table, everyone taking photos of food, social media moment",
      caption: "Weekend brunch goals achieved! 🥑🌮",
      author: "Brunch Club BLR",
      date: "2025-11-20",
      likes: 245,
    },
  ];

  const filteredMoments =
    activeCategory === "all"
      ? customerMoments
      : customerMoments?.filter(
          (moment) => moment?.category === activeCategory
        );

  return (
    <section className="py-16 bg-[var(--color-card)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in">
          <h2 className="text-3xl sm:text-4xl font-bold text-[var(--color-foreground)] mb-4">
            Customer Moments
          </h2>
          <p className="text-lg text-[var(--color-muted-foreground)] max-w-2xl mx-auto">
            Real experiences from our amazing community
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 mb-12">
          {categories?.map((category) => (
            <button
              key={category?.id}
              onClick={() => setActiveCategory(category?.id)}
              className={`flex items-center gap-2 px-6 py-3 rounded-full font-medium transition-all duration-300 ${
                activeCategory === category?.id
                  ? "bg-[var(--color-primary)] text-[var(--color-primary-foreground)] shadow-lg scale-105"
                  : "bg-[var(--color-background)] text-[var(--color-foreground)] hover:bg-[var(--color-muted)]"
              }`}
            >
              <Icon name={category?.icon} size={18} color="currentColor" />
              <span>{category?.name}</span>
            </button>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {filteredMoments?.map((moment, index) => (
            <div
              key={moment?.id}
              className="group bg-[var(--color-background)] rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 animate-slide-up"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="relative aspect-square overflow-hidden">
                <Image
                  src={moment?.image}
                  alt={moment?.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

                <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  <p className="text-white text-sm mb-3 line-clamp-2">
                    {moment?.caption}
                  </p>

                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-full bg-[var(--color-primary)] flex items-center justify-center">
                        <Icon name="User" size={16} color="#FFFFFF" />
                      </div>
                      <span className="text-white text-xs font-medium">
                        {moment?.author}
                      </span>
                    </div>

                    <div className="flex items-center gap-1">
                      <Icon name="Heart" size={16} color="#FFFFFF" />
                      <span className="text-white text-xs">
                        {moment?.likes}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[var(--color-primary)]/10 to-[var(--color-accent)]/10 rounded-2xl p-8 text-center">
          <Icon
            name="Camera"
            size={48}
            color="var(--color-primary)"
            className="mx-auto mb-4"
          />
          <h3 className="text-2xl font-bold text-[var(--color-foreground)] mb-3">
            Share Your Moment
          </h3>
          <p className="text-[var(--color-muted-foreground)] max-w-2xl mx-auto mb-6">
            Tag us @tacostreetdigital on Instagram or use #TacoStreetVibes to be
            featured in our gallery. We love seeing your experiences!
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Button
              variant="default"
              size="default"
              iconName="Instagram"
              iconPosition="left"
            >
              Follow on Instagram
            </Button>
            {/* <Button
              variant="outline"
              size="default"
              iconName="Upload"
              iconPosition="left">

              Upload Your Photo
            </Button> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerMomentsSection;
